const translitMap: {
  [key: string]: string | undefined;
} = {
  а: "a",
  б: "b",
  в: "v",
  г: "g",
  д: "d",
  е: "e",
  ё: "yo",
  ж: "zh",
  з: "z",
  и: "i",
  й: "j",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "h",
  ц: "c",
  ч: "ch",
  ш: "sh",
  щ: "sch",
  ъ: "j",
  ы: "i",
  ь: "j",
  э: "e",
  ю: "yu",
  я: "ya"
};

export const toTranslit = (word: string): string => {
  let translit = "";
  for (const letter of word.toLocaleLowerCase()) translit += translitMap[letter] ? translitMap[letter] : letter;
  return translit
    .split(/\s+/)
    .map((word) => word.match(/[a-z0-9-]/g)?.join(""))
    .join("-");
};

export const isAllowedSlug = (word: string): boolean => (word.split(/[^a-z0-9-]|\s+/g)?.length !== 1 ? false : true);
